var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconUnion = function SvgIconUnion(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 43,
    viewBox: "0 0 64 43",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 0H0V31H3V0Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 0H5V31H7V0Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 0H13V31H11V0Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H15V31H16V0Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 0H21V31H19V0Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32 0H30V31H32V30.589C31.358 29.1922 31 27.6379 31 26C31 24.3621 31.358 22.8078 32 21.411V0Z",
    fill: "current"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31V0H55V31H53Z",
    fill: "current"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34 18.4501C34.3135 18.118 34.6476 17.8054 35 17.5143V0H34V18.4501Z",
    fill: "current"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50 18.4501C50.3616 18.8331 50.6959 19.242 51 19.6738V0H50V18.4501Z",
    fill: "current"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45 15.4141C45.6973 15.6113 46.3664 15.8755 47 16.1994V0H45V15.4141Z",
    fill: "current"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41 0V15.0448C40.3132 15.1067 39.6446 15.2318 39 15.4141V0H41Z",
    fill: "current"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M64 0H62V31H64V0Z",
    fill: "current"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57 0H60V31H57V0Z",
    fill: "current"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26 0H23V31H26V0Z",
    fill: "current"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39 21.9996V30.0004C39.5814 30.4371 40.2611 30.75 41 30.9V21.1C40.2611 21.25 39.5814 21.5629 39 21.9996Z",
    fill: "current"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45 30.0004C46.2144 29.0882 47 27.6358 47 26C47 24.3642 46.2144 22.9118 45 21.9996V30.0004Z",
    fill: "current"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 26C33 21.0294 37.0294 17 42 17C46.9706 17 51 21.0294 51 26C51 28.2526 50.1724 30.3119 48.8047 31.8905L57.7071 40.7929C58.0976 41.1834 58.0976 41.8166 57.7071 42.2071C57.3166 42.5976 56.6834 42.5976 56.2929 42.2071L47.3349 33.2491C45.842 34.3496 43.997 35 42 35C37.0294 35 33 30.9706 33 26ZM42 19C38.134 19 35 22.134 35 26C35 29.866 38.134 33 42 33C45.866 33 49 29.866 49 26C49 22.134 45.866 19 42 19Z",
    fill: "current"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconUnion, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-union.566a1662.svg";
export { ForwardRef as ReactComponent };